
import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { RefreshCw, Search } from "lucide-react";

interface TrialsHeaderProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  refresh: () => void;
}

const TrialsHeader: React.FC<TrialsHeaderProps> = ({ 
  searchQuery, 
  setSearchQuery, 
  refresh 
}) => {
  return (
    <div className="flex flex-col space-y-4 md:flex-row md:items-center md:justify-between md:space-y-0">
      <div>
        <h1 className="text-2xl font-bold">Test Drives</h1>
        <p className="text-gray-500">Gerenciamento de períodos de teste gratuito</p>
      </div>
      
      <div className="flex flex-col space-y-2 md:flex-row md:space-y-0 md:space-x-2">
        <div className="relative">
          <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-gray-400" />
          <Input
            type="text"
            placeholder="Buscar test drives..."
            className="pl-8 w-full md:w-64"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
        
        <Button 
          variant="outline" 
          size="icon" 
          onClick={refresh}
          aria-label="Refresh trials"
        >
          <RefreshCw className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default TrialsHeader;
